'use strict';

import {
  UtilService
} from './util.service';

export default angular.module('leptonApp.util', [])
  .factory('Util', UtilService)
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/util/util.module.js